import cn from "classnames";
import type { ChangeEvent } from "react";
import type { ColorItem } from "../../types";
import { MenuButton } from "../MenuButton/MenuButton";
import styles from "./ColorMenu.module.css";

interface ColorMenuButtonProps {
    item: ColorItem;
    colorValue: string;
    onColorInputChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onColorClick: (item: ColorItem) => void;
}

export function ColorMenuButton({
    item,
    colorValue,
    onColorInputChange,
    onColorClick,
}: ColorMenuButtonProps) {
    const itemStyles = cn(styles.item, item.color === "#ffffff" && styles.white);

    const content =
        item.color === "transparent" ? (
            <div className={styles.transparentItem} />
        ) : (
            <>
                <div className={itemStyles} style={{ background: item.color }} />
                {item.isPicker && (
                    <input
                        className={styles.palette}
                        type="color"
                        value={colorValue}
                        onChange={onColorInputChange}
                    />
                )}
            </>
        );

    const handleClick = () => {
        onColorClick(item);
    };
    return (
        <MenuButton key={item.color} onClick={handleClick}>
            {content}
        </MenuButton>
    );
}
